import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";

import { CommunityService } from "../../../../../services";
import { Community, Errors } from "../../../../../models";

@Component({
  selector: "del-community-auth-form",
  templateUrl: "./del-community-auth-form.component.html",
  styleUrls: [
    "./del-community-auth-form.component.scss",
    "../../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelCommunityAuthForm implements OnInit {
  @Input() community: Community;
  public errors: Errors = new Errors();
  public isSubmitting: boolean = false;
  public authForm: FormGroup;

  constructor(
    private router: Router,
    private communityService: CommunityService,
    private fb: FormBuilder
  ) {
    this.authForm = this.fb.group({
      email: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  ngOnInit() {}

  public deleteCommunity() {
    this.errors = new Errors();
    this.isSubmitting = true;
    this.errors = new Errors();

    let credentials = this.authForm.value;
    this.communityService.deleteOne(this.community, credentials).subscribe(
      (data) => {
        this.fireSuccessAlert();
        this.router.navigateByUrl("/communities");
      },
      (err) => {
        this.errors = err;
        this.isSubmitting = false;
        this.fireErrorAlert();
      }
    );
  }

  public attemptLocalAuth() {
    Swal.fire({
      title: "Delete?",
      text: "Deleting community will delete all content created by you and all members. Are you sure about this?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Delete my community!",
    }).then((result) => {
      if (result.value) {
        this.authorizeDeletion();
      }
    });
  }

  public authorizeDeletion() {
    Swal.fire({
      title: "Delete?",
      text: "Vele vele, you are deleting " + this.community.name + "?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Haai, cancel!",
      confirmButtonText: "Yebo, delete!",
    }).then((result) => {
      if (result.value) {
        this.deleteCommunity();
      }
    });
  }

  public fireSuccessAlert() {
    Swal.fire({
      title: "Deleted",
      text: "Community deleted",
      type: "success",
    });
  }

  public fireErrorAlert() {
    Swal.fire("Eish!", "There were errors with your deletion", "warning");

    function errorAlert() {
      Swal.close();
    }
    setTimeout(errorAlert, 3000);
  }
}
